<script>
  import IssueLink from './issues/IssueSlim.svelte';
  import IssueSimple from './issues/IssueSimple.svelte';
  import IssueComplex from './issues/IssueComplex.svelte';
  import IssueSlim from './issues/IssueSlim.svelte';

  import { __c } from '../../utils/i18n';

  export let issue;
  export let city;
  export let level;
  // export let topic = false;
  export let inc;
  // export let category = false;

  // export let labelsDict;

  // function filterStyle(style){
  //   let filtered =  issueList.filter(d=>{return d.style == style})
  //   return filtered

  // }

  // $: console.log('issue data:', level, issue);
  // console.log("issue filtered",level, filterStyle("siimple"))

  // labelsDict = {
  //   '0': '✅ Voting',
  //   '1': '🏠 Housing and homelessness',
  //   '2': '🚓 Police and crime',
  //   '3': '🏘 On my block',
  // };

  // console.log(level,issue)
  
</script>

{#if issue.style == 'slim'}
  <IssueSlim {level} issueName={issue[__c('label')]} content={issue[`${__c('content')}_html`]} topic={issue.topic}/>
{:else if issue.style == 'links'}
  <IssueLink {level} issueName={issue[__c('label')]} content={issue[`${__c('content')}_html`]} category={issue.issue} topic={issue.topic}/>
{:else if issue.style == 'simple'}
  <IssueSimple {level} issueName={issue[__c('label')]} content={issue[`${__c('content')}_html`]} category={issue.issue} topic={issue.topic}/>
{:else if issue.style == 'complex' || 'expand'}
  <IssueComplex
    category={issue.issue}
    topic={issue.topic}
    {level}
    issueName={issue[__c('label')]}
    content={issue[`${__c('content')}_html`]}
    inc = {inc}
    {city}
  />
{/if}
